/**
 * Componente Button - ConfereAI
 *
 * Botão padronizado para o sistema.
 * Baseado no layout da página de Veículos.
 */

import React from 'react';
import './Button.css';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'danger' | 'success' | 'warning' | 'info';
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  icon?: string;
  className?: string;
  style?: React.CSSProperties;
}

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  variant = 'primary',
  type = 'button',
  disabled = false,
  icon,
  className = '',
  style,
}) => {
  return (
    <button
      type={type}
      className={`btn btn-${variant} ${className}`}
      onClick={onClick}
      disabled={disabled}
      style={style}
    >
      {icon && <i className={icon}></i>}
      {children}
    </button>
  );
};

export default Button;
